import React, { useEffect } from 'react';
import Shared from 'screens/shared';
import { actions } from 'redux/local';
import { VALIDATION, FORWARDING_RULE_ALGORITHM } from 'constant';
import { flattenArray, _t, _tf } from 'utils';
import { form, formField } from 'types';
import { useSelector } from 'react-redux';
import { ACTIONS_TYPES } from 'redux/helper';

export default ({
  item = {}, nlbProperties, dcId, nlbId,
}) => {
  const { [ACTIONS_TYPES.DATA_CENTER.GET]: datacenter = {} } = useSelector((e) => e);
  const { id, ...editProps } = item;
  const fieldsValues = { protocol: 'TCP', ...editProps };

  const ipsWithServers = (datacenter?.entities?.servers?.items || []).map((server) => {
    let itemsToReturn = server?.entities?.nics?.items?.filter((e) => e.properties.lan?.toString?.() === nlbProperties?.targetLan?.toString?.());
    itemsToReturn = itemsToReturn.map((e) => ({ serverName: server?.properties?.name, ips: e.properties.ips }));
    return itemsToReturn.reduce((t, e) => [...t, ...e?.ips?.map?.((ip) => ({ ip, serverName: e?.serverName }))], []);
  });

  const targetIpUpdateProps = () => (ipsWithServers.length
    ? flattenArray(ipsWithServers).map((e) => ([e.ip, `${e.ip} - ${e.serverName}`]))
    : [[null, (
      <span style={{ color: 'gray' }}>
        {_tf('No Servers found on LAN {0}', nlbProperties?.targetLan)}
      </span>
    )]]
  );

  const fields = [
    formField.text({ name: 'name', title: _t('Name') }),
    formField.dropdown({ name: 'algorithm', title: 'Algorithm', values: [...Object.values(FORWARDING_RULE_ALGORITHM).map((e) => ([e.name, e.label]))] }),
    formField.dropdown({
      name: 'protocol', title: 'Protocol', values: ['TCP'], disabled: true,
    }),
    formField.dropdown({ name: 'listenerIp', title: 'Listener IP', values: nlbProperties?.ips || [] }),
    formField.port({ name: 'listenerPort', title: 'Listener Port' }),
    formField.array({
      name: 'targets',
      setItemTitle: (e) => e?.ip,
      setItemDetails: (e) => <Shared.utilities.DetailsLine object={{ Port: e?.port, Weight: e?.weight }} />,
      icon: 'bullseye',
      fields: [
        formField.dropdown({ name: 'ip', title: 'IP' }),
        formField.port({ name: 'port', title: 'Port' }),
        formField.text({ name: 'weight', title: 'Weight' }),
      ],
      validations: [
        { name: 'ip', type: VALIDATION.REQUIRED },
        { name: 'port', type: VALIDATION.REQUIRED },
        { name: 'weight', type: VALIDATION.REQUIRED },
        { name: 'port', type: VALIDATION.NUMBER },
        { name: 'weight', type: VALIDATION.NUMBER },
      ],
      updateProps: () => {
        const _fields = fields.find((e) => e.name === 'targets').fields;
        _fields.find((e) => e.name === 'ip').options = targetIpUpdateProps();
        return { fields: _fields };
      },
    }),
  ];

  const validations = [
    { name: 'name', type: VALIDATION.REQUIRED },
    { name: 'name', type: VALIDATION.STRING, max: 255 },
    { name: 'algorithm', type: VALIDATION.REQUIRED },
    { name: 'listenerIp', type: VALIDATION.REQUIRED },
    { name: 'listenerPort', type: VALIDATION.REQUIRED },
    { name: 'listenerPort', type: VALIDATION.NUMBER },
  ];

  useEffect(() => {
    if (nlbProperties?.targetLan) {
      actions.dataCenter.get({ id: dcId });
    }
  }, [nlbProperties, dcId]);

  const onSubmit = async (properties) => {
    if (id) {
      return actions.networkLoadbalancer.updateForwardingRule({
        dcId, id: nlbId, forwardingRuleId: id, properties,
      });
    }

    return actions.networkLoadbalancer.createForwardingRule({ dcId, id: nlbId, properties });
  };

  return (
    <Shared.forms.Form
      {...form({
        fields,
        fieldsValues,
        onSubmit,
        isCancel: false,
        validations,
      })}
    />
  );
};
